const { conf } = require('./configService');

// TODO: rename to hostnameService
const domainService = {
  isLocalDrupalDevDomain: hostname =>
    hostname.endsWith(conf.localDrupalDevDomain),

  isLocalDevDomain: hostname =>
    ['localhost', '[::1]', '0.0.0.0'].includes(hostname) || // [::1] is the IPv6 localhost address.
    hostname.startsWith('192.168') ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),

  isLocalDomain: hostname =>
    domainService.isLocalDevDomain(hostname) ||
    domainService.isLocalDrupalDevDomain(hostname),

  isRunningOnCMS: () => {
    if (typeof window === 'object') {
      return (
        window.location.hostname.includes('cms-') ||
        domainService.isLocalDrupalDevDomain(window.location.hostname)
      );
    }
    return false;
  },

  removeDomain: href => href.replace(/.*\/\/[^/]*/, '')
};

module.exports = { domainService };
